import { Component, Input, OnChanges, SimpleChange } from '@angular/core';

@Component({
  selector: 'harp-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss'],
})
export class PasswordStrengthComponent {
  lowerLetters: boolean;
  upperLetters: boolean;
  numbers: boolean;
  symbols: boolean;
  pwd: string;

  @Input() public passwordToCheck: string;

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes.passwordToCheck.currentValue;

    if (password) {
      const regex = /(?=.*[!@#\$%\^&\*])+/;
      this.pwd = password;
      this.lowerLetters = /[a-z]+/.test(password);
      this.upperLetters = /[[A-Z]+/.test(password);
      this.numbers = /[0-9]+/.test(password);
    } else {
      this.upperLetters = false;
      this.lowerLetters = false;
      this.numbers = false;
      this.symbols = false;
      this.pwd = '';
    }
  }
}
